module.exports = __webpack_public_path__ + "static/media/nullty@4x.50de9799.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nullty@4x.png
// module id = 754
// module chunks = 0 1